// extracted by mini-css-extract-plugin
export default {"box":"CustomIcon_box__te12R","icon":"CustomIcon_icon__ryOXq","fill":"CustomIcon_fill__Gh4+M","stroke":"CustomIcon_stroke__XbeLO","noDrop":"CustomIcon_noDrop__6j4NJ"};